export function toggleSpecialitiesMenu(obj) {
    $(obj).toggleClass('open')
    $('#list-specialities').slideToggle();
    tech.core.bindCustomCheckbox();
}

var body = $('body');

var SWIPER_SCRIPTS_LOADED = false;

export function loadScripts(array, callback) {
    var loader = function(src, handler) {
        var script = document.createElement("script");
        script.src = src;
        script.onload = script.onreadystatechange = function() {
            script.onreadystatechange = script.onload = null;
            if (/MSIE ([6-9]+\.\d+);/.test(navigator.userAgent)) window.setTimeout(function() { handler(); }, 8, this);
            else handler();
        }
        var body = document.getElementsByTagName("body")[0];
        (body || document.body).appendChild(script);
    };
    (function run() {
        if (array.length != 0) {
            loader(array.shift(), run);
        } else {
            callback && callback();
        }
    })();
}

$(function() {
    var facultyUrl = $('#faculty-current-url');
    if (facultyUrl.length > 0) {
        var link = window.location.pathname;
        if (link != facultyUrl.val()) {
            window.history.replaceState({}, "", facultyUrl.val());
        }
        tech.core.setPageVisitCookie();
    }
    if ($('#course-carousel-home').length > 0) {
        var video = $('#course-carousel-home video');
        if (video.length > 0) {
            $("#faculty-color-aux").replaceWith('<style type="text/css">.nav-link-shadow{filter:drop-shadow(2px 3px 3px #000)!important}.fixed-top-menu.navbar .nav-item .nav-link{color:white}</style>');
            $('#course-carousel-home').on('slide.bs.carousel', function(ev) {
                if (ev.from != ev.to && ev.to == 0 && video[0].ended) {
                    video[0].play();
                }
            })
        }

    }
    body.one('click', loadSwipers);
    body.one('keydown', loadSwipers);
    body.one('mousemove', loadSwipers);
    body.one('touchstart', loadSwipers);
})

function loadSwipers(){
    if (!SWIPER_SCRIPTS_LOADED) {
        loadScripts([
            "/js/swiper.min.js",
            "/js/swiper-init.js"
        ])
        SWIPER_SCRIPTS_LOADED = true;
    }
    body.off('click', loadSwipers);
    body.off('keydown', loadSwipers);
    body.off('mousemove', loadSwipers);
    body.off('touchstart', loadSwipers);
}